export default __webpack_public_path__ + "static/media/signup4.7ba5099d.jpg";